import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ListItemWebsite, FakeInput } from "@similarweb/ui-components";

export const { carbon, midnight, bluegrey } = colorsPalettes;

const FakeInputContainerStyled = styled.div<{
    isCursorVisible: boolean;
    inputHeight?: string;
    disabled?: boolean;
}>`
    box-sizing: border-box;
    width: 100%;
    height: ${({ inputHeight = "42px" }) => inputHeight};
    border-radius: 3px;
    padding: 2px 0 2px 16px;
    background-color: ${({ disabled }) => (disabled ? bluegrey[200] : carbon[0])};
    color: ${({ disabled }) => (disabled ? midnight[100] : carbon[500])};
    border: 1px solid ${midnight[50]};
    cursor: ${({ isCursorVisible, disabled }) => (disabled ? "not allowed" : isCursorVisible ? "text" : "default")};
    .fake-input--container {
        height: 100%;
    }
    .fake-input--read-only {
        width: 100%;
    }

    .ListItemWebsite {
        height: 34px;
        padding: unset;
        background-color: ${({ disabled }) => disabled && bluegrey[200]};
    }
    .ItemIcon.ItemIcon--website {
        width: 24px;
        height: 24px;
        padding: unset;
    }
    .ItemText {
        color: ${({ disabled }) => (disabled ? midnight[100] : carbon[500])};
    }
`;

interface IReadOnlyInput {
    displayText: string;
    image: string;
    height?: string;
    onClick?: VoidFunction;
    onClearClick?: VoidFunction;
    disabled?: boolean;
    dataAutomation?: string;
    className?: string;
}
export const ReadOnlyInput: FC<IReadOnlyInput> = ({
    displayText,
    image,
    height,
    onClick,
    onClearClick,
    disabled,
    dataAutomation,
    className,
}) => (
    <FakeInputContainerStyled
        onClick={onClick}
        isCursorVisible={!!onClick}
        inputHeight={height}
        disabled={disabled}
        data-automation={dataAutomation}
        className={className}
    >
        <FakeInput onClear={onClearClick}>
            <ListItemWebsite
                text={displayText}
                img={image}
                isDisabled={disabled}
            />
        </FakeInput>
    </FakeInputContainerStyled>
);
